import type { ReactVirtualizer, VirtualItem } from '@tanstack/react-virtual';
import cn from 'classnames';
import type { VirtualChatRow } from '../../../types';
import { VirtualChatRowContent } from './virtual-chat-row-content';

type P = {
  paddingBottom: boolean;
  paddingTop: boolean;
  row: VirtualChatRow;
  virtualItem: VirtualItem;
  virtualizer: ReactVirtualizer<HTMLDivElement, Element>;
};

const VirtualChatRowItem = ({ paddingBottom, paddingTop, row, virtualItem, virtualizer }: P) => (
  <div
    className={cn('virtual-chat-row-item', {
      'virtual-chat-row-item--padding-bottom': paddingBottom,
      'virtual-chat-row-item--padding-top': paddingTop,
    })}
    data-index={virtualItem.index}
    // eslint-disable-next-line react-hooks/refs -- Required by @tanstack/react-virtual for dynamic row height measurement (documented row ref pattern).
    ref={virtualizer.measureElement}
    style={{ transform: `translateY(${virtualItem.start}px)` }}
  >
    <VirtualChatRowContent row={row} />
  </div>
);

export default VirtualChatRowItem;
